import { useEffect } from 'react';

/**
 * Custom hook to manage SEO meta tags using vanilla JavaScript
 * @param {Object} seoData - Object containing SEO information
 * @param {string} seoData.title - Page title
 * @param {string} seoData.description - Meta description
 * @param {string} seoData.keywords - Meta keywords
 * @param {string} seoData.author - Meta author
 * @param {string} seoData.ogTitle - Open Graph title
 * @param {string} seoData.ogDescription - Open Graph description
 * @param {string} seoData.ogType - Open Graph type
 * @param {string} seoData.ogSiteName - Open Graph site name
 */
export const SEO = (seoData) => {
    useEffect(() => {
        const {
            title,
            description,
            keywords,
            author,
            ogTitle,
            ogDescription,
            ogType,
            ogSiteName,
            canonical
        } = seoData;

        // Set document title
        if (title) {
            document.title = title;
        }

        // Helper function to set or update meta tags
        const setMetaTag = (attribute, attributeValue, content) => {
            if (!content) return;

            let element = document.querySelector(`meta[${attribute}="${attributeValue}"]`);

            if (element) {
                element.setAttribute('content', content);
            } else {
                element = document.createElement('meta');
                element.setAttribute(attribute, attributeValue);
                element.setAttribute('content', content);
                document.head.appendChild(element);
            }
        };

        // Set meta tags
        setMetaTag('name', 'description', description);
        setMetaTag('name', 'keywords', keywords);
        setMetaTag('name', 'author', author);

        // Set Open Graph tags
        setMetaTag('property', 'og:title', ogTitle);
        setMetaTag('property', 'og:description', ogDescription);
        setMetaTag('property', 'og:type', ogType);
        setMetaTag('property', 'og:site_name', ogSiteName);


        // set Canonical tags 
        if (canonical) {
            let link = document.querySelector("link[rel='canonical']");

            if (link) {
                link.setAttribute("href", canonical);
            } else {
                link = document.createElement("link");
                link.setAttribute("rel", "canonical");
                link.setAttribute("href", canonical);
                document.head.appendChild(link);
            }
        }

        // Cleanup function to reset title on unmount
        return () => {
            document.title = 'SAN Technovation';
        };
    }, [seoData]);
};
